import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  width: "25",
  height: "25",
  class: "t-sociallinks__svg",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M15 30a15 15 0 1 1 0-30 15 15 0 0 1 0 30m0-20.8a1.8 1.8 0 1 1 0 3.5 1.8 1.8 0 0 1 0-3.5m4.3 1.8a4.3 4.3 0 1 0-8.6 0 4.3 4.3 0 0 0 8.6 0m-2.6 7.8c1-.2 1.8-.6 2.6-1a1.3 1.3 0 0 0-1.4-2.2 5.5 5.5 0 0 1-5.8 0 1.3 1.3 0 0 0-1.4 2.2 8 8 0 0 0 2.5 1l-2.4 2.4a1.3 1.3 0 0 0 1.8 1.8l2.4-2.4 2.4 2.4a1.3 1.3 0 0 0 1.8-1.8z" }, null, -1)
  ]))]))
}
export default { render: render }